import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (!isHomePage) {
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinkStyle = {
    fontFamily: "var(--font-body)",
    letterSpacing: '0.08em',
    fontWeight: '400'
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || !isHomePage
          ? 'bg-white shadow-md' 
          : 'bg-gradient-to-b from-black/40 to-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img
                src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/m1azxgvy_Sceau%20en%20cire%20Rouge.png"
                alt="La Rotonde"
                className="h-14 w-auto cursor-pointer transition-opacity duration-300 hover:opacity-80"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('menu')}
              className={`text-base transition-all duration-300 hover:opacity-60 ${
                isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
              }`}
              style={navLinkStyle}
            >
              La Carte
            </button>
            <Link
              to="/evenements"
              className={`text-base transition-all duration-300 hover:opacity-60 ${
                isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
              }`}
              style={navLinkStyle}
            >
              Événements
            </Link>
            <button
              onClick={() => scrollToSection('equipe')}
              className={`text-base transition-all duration-300 hover:opacity-60 ${
                isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
              }`}
              style={navLinkStyle}
            >
              L'Équipe
            </button>
            <button
              onClick={() => scrollToSection('histoire')}
              className={`text-base transition-all duration-300 hover:opacity-60 ${
                isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
              }`}
              style={navLinkStyle}
            >
              Histoire
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base transition-all duration-300 hover:opacity-60 ${
                isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
              }`}
              style={navLinkStyle}
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('reservation')}
              className={`px-8 py-5 text-base transition-all duration-300 hover:-translate-y-0.5 ${
                isScrolled || !isHomePage
                  ? 'bg-gray-900 text-white hover:bg-gray-800' 
                  : 'bg-white text-gray-900 hover:bg-gray-100'
              }`}
              style={navLinkStyle}
            >
              Réserver
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            className={`lg:hidden transition-colors duration-300 ${
              isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t shadow-lg">
            <nav className="flex flex-col space-y-5 py-8 px-6">
              <button
                onClick={() => scrollToSection('menu')}
                className="text-left text-base text-gray-900 transition-opacity duration-300 hover:opacity-60"
                style={navLinkStyle}
              >
                La Carte
              </button>
              <Link
                to="/evenements"
                className="text-left text-base text-gray-900 transition-opacity duration-300 hover:opacity-60"
                style={navLinkStyle}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Événements
              </Link>
              <button
                onClick={() => scrollToSection('equipe')}
                className="text-left text-base text-gray-900 transition-opacity duration-300 hover:opacity-60"
                style={navLinkStyle}
              >
                L'Équipe
              </button>
              <button
                onClick={() => scrollToSection('histoire')}
                className="text-left text-base text-gray-900 transition-opacity duration-300 hover:opacity-60"
                style={navLinkStyle}
              >
                Histoire
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-base text-gray-900 transition-opacity duration-300 hover:opacity-60"
                style={navLinkStyle}
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection('reservation')}
                className="bg-gray-900 text-white hover:bg-gray-800 w-full py-5 text-base"
                style={navLinkStyle}
              >
                Réserver
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
